export const runFunctionListener = (pathFech, previusURL, blockPath, setblockPath) =>{
    const currentURL = new URL(window.location);

    if(currentURL.href != previusURL.href){
        const getParams = currentURL.search

        if(!blockPath.includes('?')){
            setblockPath(pathFech+getParams)
        }

        if(blockPath.includes('?')){
            setblockPath(`${pathFech}&${getParams.substring(1)}`)
        }
    }
}